import { invariantResponse } from '@epic-web/invariant'
import {
	json,
	type LoaderFunctionArgs,
	type MetaFunction,
} from '@remix-run/node'
import { NavLink, useLoaderData } from '@remix-run/react'
import { prisma } from '#app/utils/db.server.js'
import { cn, getPaintingImgSrc } from '#app/utils/misc.tsx'

export const meta: MetaFunction = () => [
	{ title: 'Art by Vero Miller - Paintings' },
]
export async function loader({ request }: LoaderFunctionArgs) {
	// export async function loader() {
	const url = new URL(request.url)
	const query = url.searchParams.get('q')

	const paintings = await prisma.painting.findMany({
		select: {
			id: true,
			title: true,
			price: true,
			images: {
				take: 1,
				select: {
					id: true,
					altText: true,
				},
			},
		},
		where: {
			images: { some: {} },
			...(query ? { categoryId: query } : {}),
		},
	})
	const columns = 3
	invariantResponse(paintings, 'Owner not found', { status: 404 })

	const paintingsDashboard = paintings.map((painting, index) => {
		return {
			id: painting.id,
			title: painting.title,
			image: painting.images[0]!,
			price: painting.price,
			row: Math.floor(index / columns) + 1,
			column: (index % columns) + 1,
		}
	})

	return json({ paintings: paintingsDashboard })
}

export default function PrivacyRoute() {
	const { paintings } = useLoaderData<typeof loader>()

	// Tailwind Grid cell classes lookup
	const columnClasses: Record<number, string> = {
		1: 'xl:col-start-1',
		2: 'xl:col-start-2',
		3: 'xl:col-start-3',
		4: 'xl:col-start-4',
		5: 'xl:col-start-5',
	}
	const rowClasses: Record<number, string> = {
		1: 'xl:row-start-1',
		2: 'xl:row-start-2',
		3: 'xl:row-start-3',
		4: 'xl:row-start-4',
		5: 'xl:row-start-5',
		6: 'xl:row-start-6',
	}

	return (
		<main className="grid">
			<div className="grid px-4 py-8 md:py-16 xl:grid-cols-1 xl:gap-24">
				<ul className="flex flex-wrap justify-center gap-8 sm:gap-4 md:gap-16 xl:mt-0 xl:grid xl:grid-flow-col xl:grid-cols-3">
					{paintings.map((painting, i) => (
						<div
							key={`column-${i}`}
							className={cn(
								columnClasses[painting.column],
								rowClasses[painting.row],
							)}
						>
							<NavLink
								to={painting.id}
								className="relative flex max-w-64 flex-1 items-end gap-1"
							>
								<div className="mb-1 flex flex-col gap-4">
									<span className="text-write-vertical z-1 rotate-180 font-custom text-body-xs font-extralight text-slate-400 md:text-body-md">
										- ${painting.price}CAD
									</span>
									<h2 className="text-write-vertical z-1 flex rotate-180 items-center justify-center text-nowrap font-custom text-body-xs font-bold italic md:text-body-md">
										{painting.title}
									</h2>
								</div>
								<img
									className="aspect-auto w-36 cursor-pointer shadow-none transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-gray-700 md:w-64"
									width="250px"
									src={getPaintingImgSrc(painting.image.id)}
								/>
							</NavLink>
						</div>
					))}
				</ul>
			</div>
		</main>
	)
}
